"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDataSchemaInstanceAccessor = exports.AppDataSchemaInstancesAccessor = exports.AppDataSchemaAccessor = exports.AppDataSchemasAccessor = void 0;
const accessors_1 = require("../accessors");
class AppDataSchemasAccessor extends accessors_1.ElementListAccessor {
    constructor(client) {
        super(client, 'app-data-schemas');
    }
}
exports.AppDataSchemasAccessor = AppDataSchemasAccessor;
class AppDataSchemaAccessor extends accessors_1.ElementAccessor {
    constructor(client, idOrKey) {
        super({
            client,
            path: 'app-data-schemas',
            idOrKey,
        });
    }
}
exports.AppDataSchemaAccessor = AppDataSchemaAccessor;
class AppDataSchemaInstancesAccessor extends accessors_1.ElementInstanceListAccessor {
    constructor(client) {
        super(client, 'app-data-schema-instances');
    }
}
exports.AppDataSchemaInstancesAccessor = AppDataSchemaInstancesAccessor;
class AppDataSchemaInstanceAccessor extends accessors_1.ElementInstanceAccessor {
    constructor(client, selector) {
        super({
            client,
            instancePath: 'app-data-schema-instance',
            selector,
        });
    }
}
exports.AppDataSchemaInstanceAccessor = AppDataSchemaInstanceAccessor;
//# sourceMappingURL=accessors.js.map